import React from 'react';
import { Button } from 'reactstrap';

export default ({ column, direction, columns, onApply }) => {
  if (!column) return null;

  const colName = columns.find(c => c.key === column)?.name || column;

  return (
    <div className="d-flex justify-content-between align-items-center pt-2 border-top">
      <span style={{ fontSize: '0.85rem', color: '#555' }}>
        Current: {colName} ({direction})
      </span>
      <Button
        color="success"
        size="sm"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onApply();
        }}
      >
        Apply
      </Button>
    </div>
  );
};
